import { HouseType } from "../houseTypes";

export const isHouseTypeInvalid = (houseType: HouseType | undefined): boolean =>
  houseType === HouseType.SEMI_DETACHED_HOUSE_HORIZONTAL ||
  houseType === HouseType.SEMI_DETACHED_HOUSE_WHOLE ||
  houseType === HouseType.AGRICULTURAL ||
  houseType === HouseType.OTHER;
